import { defineMessages } from 'react-intl';

export default defineMessages({
  items: {
    id: 'cboard.components.SelectedCounter.items',
    defaultMessage: 'items'
  }
});
